/* tslint:disable */
/* eslint-disable */
/**
 * Orders and payments
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: 1.33.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateCustomerPaymentNew } from '../models';
// @ts-ignore
import type { CreateCustomerPaymentRequest } from '../models';
// @ts-ignore
import type { CustomerPayment } from '../models';
// @ts-ignore
import type { CustomerPayments } from '../models';
// @ts-ignore
import type { NotFoundError } from '../models';
// @ts-ignore
import type { PreconditionFailedError } from '../models';
// @ts-ignore
import type { ValidationError } from '../models';
/**
 * CustomerPaymentsApi - axios parameter creator
 * @export
 */
export const CustomerPaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel customer payment by ID
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCustomerPayment: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('cancelCustomerPayment', 'paymentId', paymentId)
            const localVarPath = `/customer-payments/{payment-id}`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new customer payment
         * @param {CreateCustomerPaymentRequest} createCustomerPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerPayment: async (createCustomerPaymentRequest: CreateCustomerPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCustomerPaymentRequest' is not null or undefined
            assertParamExists('createCustomerPayment', 'createCustomerPaymentRequest', createCustomerPaymentRequest)
            const localVarPath = `/customer-payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomerPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a customer payment by ID
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPayment: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('getCustomerPayment', 'paymentId', paymentId)
            const localVarPath = `/customer-payments/{payment-id}`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all customer payments
         * @param {string} [orderReference] Filter by order reference number.
         * @param {string} [orderId] Filter by order id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomerPayments: async (orderReference?: string, orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderReference !== undefined) {
                localVarQueryParameter['orderReference'] = orderReference;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies a customer payment
         * @summary Modify customer payment
         * @param {CreateCustomerPaymentNew} createCustomerPaymentNew 
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerPayment: async (createCustomerPaymentNew: CreateCustomerPaymentNew, paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCustomerPaymentNew' is not null or undefined
            assertParamExists('updateCustomerPayment', 'createCustomerPaymentNew', createCustomerPaymentNew)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('updateCustomerPayment', 'paymentId', paymentId)
            const localVarPath = `/customer-payments/{payment-id}`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomerPaymentNew, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerPaymentsApi - functional programming interface
 * @export
 */
export const CustomerPaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerPaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel customer payment by ID
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCustomerPayment(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCustomerPayment(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPaymentsApi.cancelCustomerPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new customer payment
         * @param {CreateCustomerPaymentRequest} createCustomerPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerPayment(createCustomerPaymentRequest: CreateCustomerPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerPayment(createCustomerPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPaymentsApi.createCustomerPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a customer payment by ID
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerPayment(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerPayment(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPaymentsApi.getCustomerPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all customer payments
         * @param {string} [orderReference] Filter by order reference number.
         * @param {string} [orderId] Filter by order id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomerPayments(orderReference?: string, orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPayments>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomerPayments(orderReference, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPaymentsApi.listCustomerPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modifies a customer payment
         * @summary Modify customer payment
         * @param {CreateCustomerPaymentNew} createCustomerPaymentNew 
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerPayment(createCustomerPaymentNew: CreateCustomerPaymentNew, paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerPayment(createCustomerPaymentNew, paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPaymentsApi.updateCustomerPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerPaymentsApi - factory interface
 * @export
 */
export const CustomerPaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerPaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel customer payment by ID
         * @param {CustomerPaymentsApiCancelCustomerPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCustomerPayment(requestParameters: CustomerPaymentsApiCancelCustomerPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelCustomerPayment(requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new customer payment
         * @param {CustomerPaymentsApiCreateCustomerPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerPayment(requestParameters: CustomerPaymentsApiCreateCustomerPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerPayment> {
            return localVarFp.createCustomerPayment(requestParameters.createCustomerPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a customer payment by ID
         * @param {CustomerPaymentsApiGetCustomerPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPayment(requestParameters: CustomerPaymentsApiGetCustomerPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerPayment> {
            return localVarFp.getCustomerPayment(requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all customer payments
         * @param {CustomerPaymentsApiListCustomerPaymentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomerPayments(requestParameters: CustomerPaymentsApiListCustomerPaymentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CustomerPayments> {
            return localVarFp.listCustomerPayments(requestParameters.orderReference, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Modifies a customer payment
         * @summary Modify customer payment
         * @param {CustomerPaymentsApiUpdateCustomerPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerPayment(requestParameters: CustomerPaymentsApiUpdateCustomerPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerPayment> {
            return localVarFp.updateCustomerPayment(requestParameters.createCustomerPaymentNew, requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelCustomerPayment operation in CustomerPaymentsApi.
 * @export
 * @interface CustomerPaymentsApiCancelCustomerPaymentRequest
 */
export interface CustomerPaymentsApiCancelCustomerPaymentRequest {
    /**
     * Payment ID.
     * @type {string}
     * @memberof CustomerPaymentsApiCancelCustomerPayment
     */
    readonly paymentId: string
}

/**
 * Request parameters for createCustomerPayment operation in CustomerPaymentsApi.
 * @export
 * @interface CustomerPaymentsApiCreateCustomerPaymentRequest
 */
export interface CustomerPaymentsApiCreateCustomerPaymentRequest {
    /**
     * 
     * @type {CreateCustomerPaymentRequest}
     * @memberof CustomerPaymentsApiCreateCustomerPayment
     */
    readonly createCustomerPaymentRequest: CreateCustomerPaymentRequest
}

/**
 * Request parameters for getCustomerPayment operation in CustomerPaymentsApi.
 * @export
 * @interface CustomerPaymentsApiGetCustomerPaymentRequest
 */
export interface CustomerPaymentsApiGetCustomerPaymentRequest {
    /**
     * Payment ID.
     * @type {string}
     * @memberof CustomerPaymentsApiGetCustomerPayment
     */
    readonly paymentId: string
}

/**
 * Request parameters for listCustomerPayments operation in CustomerPaymentsApi.
 * @export
 * @interface CustomerPaymentsApiListCustomerPaymentsRequest
 */
export interface CustomerPaymentsApiListCustomerPaymentsRequest {
    /**
     * Filter by order reference number.
     * @type {string}
     * @memberof CustomerPaymentsApiListCustomerPayments
     */
    readonly orderReference?: string

    /**
     * Filter by order id.
     * @type {string}
     * @memberof CustomerPaymentsApiListCustomerPayments
     */
    readonly orderId?: string
}

/**
 * Request parameters for updateCustomerPayment operation in CustomerPaymentsApi.
 * @export
 * @interface CustomerPaymentsApiUpdateCustomerPaymentRequest
 */
export interface CustomerPaymentsApiUpdateCustomerPaymentRequest {
    /**
     * 
     * @type {CreateCustomerPaymentNew}
     * @memberof CustomerPaymentsApiUpdateCustomerPayment
     */
    readonly createCustomerPaymentNew: CreateCustomerPaymentNew

    /**
     * Payment ID.
     * @type {string}
     * @memberof CustomerPaymentsApiUpdateCustomerPayment
     */
    readonly paymentId: string
}

/**
 * CustomerPaymentsApi - object-oriented interface
 * @export
 * @class CustomerPaymentsApi
 * @extends {BaseAPI}
 */
export class CustomerPaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Cancel customer payment by ID
     * @param {CustomerPaymentsApiCancelCustomerPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentsApi
     */
    public cancelCustomerPayment(requestParameters: CustomerPaymentsApiCancelCustomerPaymentRequest, options?: RawAxiosRequestConfig) {
        return CustomerPaymentsApiFp(this.configuration).cancelCustomerPayment(requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new customer payment
     * @param {CustomerPaymentsApiCreateCustomerPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentsApi
     */
    public createCustomerPayment(requestParameters: CustomerPaymentsApiCreateCustomerPaymentRequest, options?: RawAxiosRequestConfig) {
        return CustomerPaymentsApiFp(this.configuration).createCustomerPayment(requestParameters.createCustomerPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a customer payment by ID
     * @param {CustomerPaymentsApiGetCustomerPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentsApi
     */
    public getCustomerPayment(requestParameters: CustomerPaymentsApiGetCustomerPaymentRequest, options?: RawAxiosRequestConfig) {
        return CustomerPaymentsApiFp(this.configuration).getCustomerPayment(requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all customer payments
     * @param {CustomerPaymentsApiListCustomerPaymentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentsApi
     */
    public listCustomerPayments(requestParameters: CustomerPaymentsApiListCustomerPaymentsRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerPaymentsApiFp(this.configuration).listCustomerPayments(requestParameters.orderReference, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modifies a customer payment
     * @summary Modify customer payment
     * @param {CustomerPaymentsApiUpdateCustomerPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentsApi
     */
    public updateCustomerPayment(requestParameters: CustomerPaymentsApiUpdateCustomerPaymentRequest, options?: RawAxiosRequestConfig) {
        return CustomerPaymentsApiFp(this.configuration).updateCustomerPayment(requestParameters.createCustomerPaymentNew, requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }
}

